import { render, staticRenderFns } from "./issue_card_statistics.vue?vue&type=template&id=b375c0aa"
import script from "./issue_card_statistics.vue?vue&type=script&lang=js"
export * from "./issue_card_statistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports